<template>
    <div class="mobile-news-detail">
        <HeaderMobile />

        <div class="detail-wrap" v-loading="loading">
            <template v-if="detail.id">
                <!-- 面包屑 -->
                <div class="breadcrumb">
                    <span @click="$router.push('/mobile')">首页</span>
                    <i class="el-icon-arrow-right"></i>
                    <span @click="$router.push('/mobile/news?type=' + detail.type)">
                        {{ detail.type === 1 ? '市场动态' : '通知公告' }}
                    </span>
                    <i class="el-icon-arrow-right"></i>
                    <span class="current">详情</span>
                </div>

                <!-- 文章内容 -->
                <div class="article">
                    <h1 class="article-title">{{ detail.title }}</h1>
                    <div class="article-meta">
                        <span class="type-tag" :class="detail.type === 1 ? 'tag-market' : 'tag-notice'">
                            {{ detail.type === 1 ? '市场动态' : '通知公告' }}
                        </span>
                        <span><i class="el-icon-time"></i> {{ detail.create_time }}</span>
                    </div>
                    <div class="article-content" v-html="detail.content"></div>
                </div>

                <!-- 上一篇/下一篇 -->
                <div class="nav-articles">
                    <div class="nav-item" v-if="detail.prev_id" @click="goDetail(detail.prev_id)">
                        <span class="nav-label">上一篇</span>
                        <span class="nav-title">{{ detail.prev_title }}</span>
                    </div>
                    <div class="nav-item" v-if="detail.next_id" @click="goDetail(detail.next_id)">
                        <span class="nav-label">下一篇</span>
                        <span class="nav-title">{{ detail.next_title }}</span>
                    </div>
                </div>
            </template>

            <div class="empty-state" v-else-if="!loading">
                <i class="el-icon-document-delete"></i>
                <p>内容不存在或已删除</p>
                <el-button type="primary" size="small" @click="$router.back()">返回</el-button>
            </div>
        </div>

        <FooterMobile />
    </div>
</template>

<script>
import HeaderMobile from '@/components/mobile/header.vue';
import FooterMobile from '@/components/mobile/fotter.vue';
import { getNewsDetail } from '@/api/news';

export default {
    name: 'MobileNewsDetail',
    components: { HeaderMobile, FooterMobile },
    data() {
        return {
            detail: {},
            loading: false
        };
    },
    created() {
        this.fetchDetail();
    },
    watch: {
        '$route.params.id'() {
            this.fetchDetail();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    },
    methods: {
        fetchDetail() {
            this.loading = true;
            this.detail = {};
            getNewsDetail(this.$route.params.id)
                .then(res => {
                    if (res.code) this.detail = res.data || {};
                })
                .finally(() => { this.loading = false; });
        },
        goDetail(id) {
            if (!id) return;
            this.$router.push(`/mobile/news/${id}`);
        }
    }
};
</script>

<style scoped>
.mobile-news-detail {
    min-height: 100vh;
    background: #f5f5f5;
    padding-top: 60px;
}

.detail-wrap {
    padding: 12px 15px;
    min-height: 300px;
}

/* 面包屑 */
.breadcrumb {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #999;
    margin-bottom: 12px;
}
.breadcrumb span {
    cursor: pointer;
}
.breadcrumb span:active {
    color: #e1251b;
}
.breadcrumb .current {
    color: #666;
}
.breadcrumb i {
    font-size: 10px;
    color: #ddd;
}

/* 文章 */
.article {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.05);
}
.article-title {
    font-size: 18px;
    font-weight: 700;
    color: #1f2937;
    margin: 0 0 12px;
    line-height: 1.5;
}
.article-meta {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 12px;
    color: #bbb;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
}
.article-meta i {
    margin-right: 3px;
}
.type-tag {
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 500;
}
.tag-notice {
    background: #fff3e0;
    color: #e65100;
}
.tag-market {
    background: #e3f2fd;
    color: #1565c0;
}
.article-content {
    font-size: 15px;
    color: #333;
    line-height: 1.9;
    word-break: break-word;
}
.article-content >>> img {
    max-width: 100%;
    border-radius: 6px;
    margin: 8px 0;
}
.article-content >>> p {
    margin: 0 0 12px;
}

/* 上下篇 */
.nav-articles {
    margin-top: 12px;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 4px rgba(0,0,0,0.05);
}
.nav-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 15px;
    border-bottom: 1px solid #f5f5f5;
}
.nav-item:last-child {
    border-bottom: none;
}
.nav-item:active {
    background: #fafafa;
}
.nav-label {
    font-size: 11px;
    color: #999;
    background: #f5f5f5;
    padding: 2px 8px;
    border-radius: 4px;
    flex-shrink: 0;
}
.nav-title {
    font-size: 13px;
    color: #444;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 空状态 */
.empty-state {
    text-align: center;
    padding: 60px 0;
    color: #ccc;
}
.empty-state i {
    font-size: 40px;
    display: block;
    margin-bottom: 10px;
}
.empty-state p {
    font-size: 14px;
    margin: 0 0 16px;
}
</style>
